import React from 'react'
import { Breadcrumb } from 'component-library/navigation/Breadcrumb/Breadcrumb'
import { Topic } from 'common/client-data-types/topic'
import { Props as SponsoredTopicProps } from 'component-library/advertising/SponsoredTopic/SponsoredTopic'
import { createRegisterableComponent } from 'common/routing/page-definition'
import { ThemeMargins } from 'component-library/__styling/settings/metrics'

export interface BreadcrumbTopicRouteProps {
    topic?: Topic
    profile?: string
    title?: string
    items?: Array<{ text: string }>
    enableHeaderTag?: boolean
    verticalSpacing?: keyof ThemeMargins | undefined
}

export type BreadcrumbRouteProps = BreadcrumbTopicRouteProps & SponsoredTopicProps
export const BreadcrumbRegistration = createRegisterableComponent(
    'breadcrumb',
    (props: BreadcrumbRouteProps) => {
        const items = []
        const sponsor = props.sponsor

        if (props.topic) {
            const topic = props.topic
            const parent = topic.parent

            if (parent) {
                items.push({
                    text: parent.title,
                    href: `/${parent.id}`,
                })
            }
            items.push({
                text: topic.title,
                href: `/${topic.id}`,
            })

            return (
                <Breadcrumb
                    enableHeaderTag={props.enableHeaderTag}
                    items={items}
                    sponsor={sponsor}
                    verticalSpacing={props.verticalSpacing}
                />
            )
        }

        if (props.profile) {
            items.push({ text: 'Profile' })
            items.push({ text: props.profile })

            return (
                <Breadcrumb
                    items={items}
                    sponsor={sponsor}
                    verticalSpacing={props.verticalSpacing}
                />
            )
        }

        if (props.items) {
            return (
                <Breadcrumb
                    items={props.items}
                    enableHeaderTag={props.enableHeaderTag || true}
                    verticalSpacing={props.verticalSpacing}
                />
            )
        }

        if (props.title) {
            return (
                <Breadcrumb
                    items={[{ text: props.title }]}
                    enableHeaderTag={props.enableHeaderTag || true}
                    verticalSpacing={props.verticalSpacing}
                />
            )
        }

        return null
    }
)
